import { Button, Form, Modal, Stack } from "react-bootstrap"
import InputField from "../common/InputField"
import React, { useEffect, useState } from "react"
import { vehicleLengthOptions } from "../../constants/Constants"
import { Loader } from "../common/Loader"
import { ReactSelect } from "../common/ReactSelect"
import { UploadImage } from "../common/UploadImage"
import { BiImageAdd } from "react-icons/bi"
import { addVehicle, updateVehicle } from "../../services/Networkcall"
import { errorAlert, successAlert } from "../common/Alert"

const EditVehicle = ({ show, closeModal, vehicle, fetchVehicleList }) => {
    const [fdata, setFdata] = useState({ name: "", licensePlate: "", state: "", vehicleType: null, image: null, status: "ACTIVE" });
    const [error, setError] = useState({ name: "", licensePlate: "", state: "", vehicleType: "", image: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (vehicle) {
            const exData = {
                name: vehicle?.vehicleName,
                licensePlate: vehicle?.licensePlate,
                state: vehicle?.state,
                vehicleType: vehicle?.length,
                status: vehicle?.status,
            }
            setFdata(exData);
        }
    }, [vehicle])


    const options = vehicleLengthOptions.map((e) => ({
        value: e.value,
        label: (
            <Stack direction="horizontal" className="justify-content-between w-100 text-start" gap={5}  >
                <span className="fw-bold f-sm-8 ">{e.name.v_type}</span>
                <span className="text-start text-sm-end text-nowrap f-sm-8 w-25">{e.name.v_length}</span>
            </Stack>
        ),
        isDisabled: e.isDisabled || false,
    }));

    const updateHandler = async (e) => {
        e.preventDefault();

        let isValid = true;

        const newError = { name: "", licensePlate: "", state: "", vehicleType: "" };

        if (!fdata.name || !fdata.name.trim()) { isValid = false; newError.name = "Vehicle name is required"; }
        else if (fdata.name.trim().length < 2) { isValid = false; newError.name = "Vehicle name must be at least 2 characters"; }

        if (!fdata.state || !fdata.state.trim()) { isValid = false; newError.state = "State is required"; }

        if (!fdata.vehicleType) { isValid = false; newError.vehicleType = "Vehicle type is required"; }

        setError(newError);
        if (!isValid) return;

        if (isValid) {
            const payload = {
                "vehicleId": vehicle?._id,
                "licensePlate": fdata.licensePlate,
                "state": fdata.state,
                "vehicleName": fdata.name,
                "length": fdata.vehicleType,
                "status": fdata?.status,
            }

            try {
                const res = await updateVehicle(payload);
                if (res?.success) {
                    successAlert({ message: res?.message })
                    closeModal();
                    fetchVehicleList();
                }
                else {
                    errorAlert({ message: res?.message })
                }
            } catch (err) {
                errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong." })
            }
            finally {
                setLoading(false);
            }
        }
    }


    const inputHandler = (e) => {

        if (!e.target) {
            setFdata((prev) => ({ ...prev, vehicleType: e.value }));
            setError((prev) => ({ ...prev, vehicleType: "" }));
            return;
        }
        const { name, value } = e.target;
        setFdata((pre) => ({ ...pre, [name]: value }));
        setError((pre) => ({ ...pre, [name]: "" }));
    }


    return (
        <>
            <Loader show={loading} />
            <Modal show={show} onHide={closeModal} centered backdrop={'static'}>
                <Modal.Header closeButton><p className="w-100 text-center mb-0 fw-bold">Edit Vehicle</p></Modal.Header>
                <Modal.Body>
                    <Form onSubmit={updateHandler}>
                        <Stack direction="vertical" gap={3}>
                            <div className="d-flex align-items-center justify-content-between">
                                <label className="form-label mb-0 fw-semibold">
                                    Vehicle Status
                                </label>

                                <div className="d-flex align-items-center">
                                     <span
                                        className={`fw-semibold me-3 ${fdata?.status === "ACTIVE"
                                                ? "text-success"
                                                : "text-danger"
                                            }`}
                                    >
                                        {fdata?.status === "ACTIVE"
                                            ? "Active"
                                            : "Inactive"}
                                    </span>
                                    <Form.Check
                                        type="switch"
                                        id="vehicle-status-switch"
                                        checked={fdata?.status === "ACTIVE"}
                                        className="fs-4"
                                        onChange={(e) =>
                                            setFdata({
                                                ...fdata,
                                                status: e.target.checked
                                                    ? "ACTIVE"
                                                    : "INACTIVE",
                                            })
                                        }
                                    />

                                   

                                </div>
                            </div>
                            <InputField
                                type={"text"}
                                label={'Vehicle Name'}
                                value={fdata.name}
                                onChange={inputHandler}
                                name={'name'}
                                placeholder="Enter vehicle name"
                            />

                            <InputField
                                type={"text"}
                                label={'License Plate'}
                                value={fdata.licensePlate}
                                name={'licensePlate'}
                                readOnly={true}
                                disabled={true}
                                placeholder="Enter License plate"
                            />
                            <InputField
                                type={"text"}
                                label={'State'}
                                value={fdata.state}
                                onChange={inputHandler}
                                name={'state'}
                                placeholder="Enter state"
                            />
                            <ReactSelect
                                label={'Vehicle Type & Length'}
                                value={options.find(
                                    option =>
                                        option.value ===
                                        fdata.vehicleType
                                )}
                                options={options}
                                name={'vehicleType'}
                                onChange={inputHandler}
                            />
                            <Button className="w-100 rounded login-btn " variant="primary" type="submit">Update</Button>
                        </Stack>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default React.memo(EditVehicle);